import { maxLengthMessage, requiredMessage } from "../validationMessages";

import { trimmedString } from "./trimmedString";

const MAX_LENGTH = 60;

export const policeDepartmentValidator = trimmedString.max(
  MAX_LENGTH,
  maxLengthMessage(MAX_LENGTH)
);
export const policeDepartmentValidatorRequired = trimmedString
  .max(MAX_LENGTH, maxLengthMessage(MAX_LENGTH))
  .required(requiredMessage);
